import { styled as r } from "styled-components";
import { Theme as t } from "../../styles/themes/index.js";
var p = /* @__PURE__ */ ((o) => (o.LEFT = "--left", o.TOP = "--top", o.BOTTOM = "--bottom", o))(p || {});
const a = r.div`
  backdrop-filter: blur(2.5px);
  -webkit-backdrop-filter: blur(2.5px);
  -moz-backdrop-filter: blur(2.5px);
  -o-backdrop-filter: blur(2.5px);
  border-radius: 30px;
`, l = r.div`
  display: flex;
  background-color: rgb(${t.colors.Alpha});
  opacity: 0.7;
  align-items: center;
  max-width: 251px;
  padding: 11px 16px;
  border-radius: 30px;
`, d = r.span`
  width: 16px;
  background-color: rgb(${t.colors.Alpha});
  height: 16px;
  border-radius: 2px;
  position: absolute;
  top: var(${"--top"});
  bottom: var(${"--bottom"});
  left: var(${"--left"});
  transform: rotate(45deg);
`;
export {
  d as TooltipArrow,
  p as TooltipArrowVars,
  a as TooltipContainer,
  l as TooltipContent
};
